import { FC, ReactNode } from 'react';

import { CapQuestLogo } from '../../../assets/icons/index';
import { AppFormattedMessage } from '../../../components/app-formatted-message/index';

type PublicStatusCardProps = {
  children: ReactNode;
};

/**
 * The card the viewer meets before the cap table itself — waiting, the password gate, or a link
 * that no longer resolves. The design draws one card for all of them, and the attribution sits
 * below a rule that runs the full width, so it is edge-to-edge rather than inside the padding.
 */
export const PublicStatusCard: FC<PublicStatusCardProps> = ({ children }) => (
  <div className="flex min-h-screen items-center justify-center bg-gray-50 px-4 py-8">
    <div className="flex w-full max-w-[458px] flex-col items-center gap-8 rounded-lg bg-white p-8 shadow-xl">
      {children}

      <div className="-mx-8 flex w-[calc(100%+64px)] items-center justify-center gap-1 border-t border-gray-100 px-8 pt-5">
        <span className="text-xs font-medium leading-[18px] text-gray-400">
          <AppFormattedMessage id="SHARE_PUBLIC_POWERED_BY" />
        </span>
        <CapQuestLogo mode="full" />
      </div>
    </div>
  </div>
);
